import styled from '@emotion/styled';

export const HR = styled.hr`
  margin: 0;
  border: 1px solid ${({ theme }) => theme.colors.divider};
`;
